export enum MobileDeviceType {
    ANDROID = 'android',
    IOS = 'ios',
    UNKNOWN = 'unknown',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/MobileDeviceType.ts